import { TweenMax, Power2 } from 'gsap'

export default {
  mounted () {
    TweenMax.staggerFrom('[data-FadeInLeft-stagger]', 1, {
      x: '-55',
      opacity: 0,
      autoAlpha: 0,
      ease: Power2.easeOut,
      force3D: true,
    }, 0.2)
  },
}
